import { EntityUpdate } from './entity-update.model';

export class BaseEditableEntity {
    creationDate: Date;
    lastUpdateDate: Date;
    updates: EntityUpdate[];
}
